import { v7 as uuidv7 } from "uuid";
import { activeSiteCountry } from "@config/site/site-config";

const clientID = {
    US: "100343",
    CA: "100447",
};

let sessionID: string | null = null;
export const getSessionIDForKount = () => {
    if (sessionID) {
        return sessionID;
    }
    sessionID = uuidv7().replace(/-/g, "").substring(0, 32);
    return sessionID;
};

const kountConfig = {
    clientID: clientID[activeSiteCountry],
    // We are using includes because the value for Adyen Environment can be either LIVE or LIVE-countryCode (e.g. LIVE-US)
    environment: process.env.NEXT_PUBLIC_ADYEN_ENVIRONMENT?.includes("LIVE") ? "PROD" : "TEST",
    isSinglePageApp: false,
};

export const initializeKount = async (): Promise<unknown | null> => {
    if (activeSiteCountry === "CA" || activeSiteCountry === "US") {
        const { default: kountSDK } = await import("@kount/kount-web-client-sdk");
        const KountSessionID = getSessionIDForKount();
        return new kountSDK(kountConfig, KountSessionID);
    }
    return null;
};
